import PropTypes from 'prop-types';
import { useToggleState } from 'app/lib/hooks';
import { Defaults } from 'app/lib/constants';
import {
    Dialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalActions
} from 'app/components/core/Modal';
import { LinkButton } from 'app/components/core/LinkButton';
import { Button, ButtonVariant } from 'app/components/core/Button';
import { Collapsible } from 'app/components/core/Collapsible';
import * as styles from './ErrorBoundaryDialog.css';

export function ErrorBoundaryDialog({ error, onClose = Defaults.NOOP }) {
    const [isDetailsCollapsed, toggleDetails] = useToggleState(true);

    return (
        <Dialog width={600} onClose={onClose} testId="global-error-dialog">
            <ModalHeader>
                <ModalTitle>Oops, something went wrong</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <p>You have encountered this error: {error.message}</p>
                <LinkButton onClick={toggleDetails}>
                    {isDetailsCollapsed ? 'Show Details' : 'Hide Details'}
                </LinkButton>
                <Collapsible onToggle={toggleDetails} collapsed={isDetailsCollapsed}>
                    <div className={styles.details}>{error.stack}</div>
                </Collapsible>
            </ModalBody>
            <ModalActions as="footer">
                <Button variant={ButtonVariant.PRIMARY} onClick={onClose}>
                    OK
                </Button>
            </ModalActions>
        </Dialog>
    );
}

ErrorBoundaryDialog.propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string,
        stack: PropTypes.string
    }).isRequired,
    onClose: PropTypes.func
};
